module.exports = __webpack_public_path__ + "img/2M.89f59468.png";